import { HStack, Icon, Menu, MenuButton, MenuItem, MenuList, Text, useDisclosure } from '@chakra-ui/react';
import { isRequestDrawerEnabledForTenant, RequestDrawers } from '@pelicargo/tenants';
import { HiChevronRight } from 'react-icons/hi2';

import { EmailListMenuItem } from './EmailListMenuItem';

export type SubMenuItemConfig = {
  drawer?: RequestDrawers;
  label: string;
  isDisabled?: boolean;
  onClick: () => void;
};

export type Props = {
  label: string;
  items: SubMenuItemConfig[];
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  otherMenuDisclosure: ReturnType<typeof useDisclosure>;
  menuItemHoverBg: string;
};

export const SubMenu = ({ label, items, isOpen, onOpen, onClose, otherMenuDisclosure, menuItemHoverBg }: Props) => {
  const someChildIsVisible = items.some((item) => isRequestDrawerEnabledForTenant(item?.drawer));
  if (!someChildIsVisible) return null;

  return (
    <Menu
      placement="right-start"
      gutter={0}
      autoSelect={false}
      modifiers={[{ name: 'flip', enabled: false }]}
      isOpen={isOpen}
      onClose={onClose}
    >
      <MenuButton
        as={MenuItem}
        _hover={{ bg: menuItemHoverBg }}
        onMouseEnter={() => {
          otherMenuDisclosure.onClose();
          onOpen();
        }}
        onMouseLeave={onClose}
        onClick={onOpen}
      >
        <HStack justify="space-between" w="full">
          <Text>{label}</Text>
          <Icon as={HiChevronRight} color="gray.400" />
        </HStack>
      </MenuButton>
      <MenuList minW="220px" onMouseEnter={onOpen} onMouseLeave={onClose}>
        {items.map((item, idx) => (
          <EmailListMenuItem
            drawer={item.drawer}
            key={idx}
            isDisabled={item.isDisabled}
            onClick={item.onClick}
            _hover={{ bg: menuItemHoverBg }}
          >
            {item.label}
          </EmailListMenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};
